import React from 'react';

// Make hatTarget 'ref="hatTarget"'
// Add '.fill' to all body elements
// Add '.fill--face' to nose

class HeadHOC extends React.Component {
	componentDidMount() {
		this.props.getHatTargetCoords(this.refs.hatTarget);
	}
}

export default class Heads extends HeadHOC {
	render() {
		return (
			<g>
				<circle ref="hatTarget" cx="200.0660217" cy="139.9579163" r="0" />
				<path className="fill ear ear--right" d="M226.3887634,124.6551819
					c-9.0610962,16.5014343-1.0314789,31.0526733,13.4719391,43.0548401
					c23.9475861,19.8175812,36.1287994,7.9175873,45.1898956-8.583847s8.977356-42.769104-7.7424011-52.9901352
					S235.4498596,108.1537399,226.3887634,124.6551819z" />
				<path className="fill ear ear--left" d="M176.3446198,124.6551819
					c9.0610962,16.5014343,1.0314789,31.0526733-13.4719391,43.0548401
					c-23.9475861,19.8175812-36.1288071,7.9175873-45.1898956-8.583847s-8.977356-42.769104,7.7424011-52.9901352
					S167.2835236,108.1537399,176.3446198,124.6551819z" />
				<path className="fill" d="M258.3789673,192.372757c-2.2915039,0-4.3351135-1.6208954-4.7874908-3.9547882
					c-0.5127563-2.6469421,1.2172699-5.2080688,3.8647308-5.7208252l27.4408875-5.3145294
					c2.6517029-0.5101166,5.2080688,1.2183228,5.7208252,3.8647308c0.5127563,2.6469421-1.2172546,5.2080688-3.8647461,5.7208252
					l-27.4408569,5.3145447C258.9987183,192.3430939,258.6861877,192.372757,258.3789673,192.372757z" />
				<path className="fill" d="M283.8249817,208.8217163c-0.2426147,0-0.4862671-0.0180054-0.7331238-0.0550842
					l-25.4152832-3.8250122c-2.6654816-0.4009857-4.5014496-2.8874207-4.1009827-5.5539703
					c0.4015198-2.6670685,2.8932495-4.5009003,5.5545044-4.1004486l25.4152832,3.8250122
					c2.6654663,0.4009857,4.5014343,2.8874207,4.1009827,5.5539551
					C288.2819214,207.0858765,286.1991272,208.8217163,283.8249817,208.8217163z" />
				<path className="fill" d="M272.620636,227.2549438c-0.7489929,0-1.508606-0.1732025-2.2215881-0.5381775
					l-22.8748169-11.7186737c-2.3995667-1.2289276-3.3488007-4.1709137-2.1188202-6.5704803
					c1.2289124-2.3995667,4.1698456-3.3482666,6.5704651-2.1188202l22.8748322,11.718689
					c2.3995667,1.2289124,3.3487854,4.1708984,2.1188049,6.5704651
					C276.1050415,226.2850647,274.394104,227.2549438,272.620636,227.2549438z" />
				<path className="fill" d="M143.2685699,192.372757c-0.3082886,0-0.619751-0.029129-0.9333344-0.0900421
					l-27.4408875-5.3145447c-2.6474762-0.5127563-4.3774948-3.0738831-3.8647385-5.7208252
					c0.5127563-2.6474762,3.0733566-4.3801422,5.7208252-3.8647308l27.4408798,5.3145294
					c2.6474762,0.5127563,4.3774872,3.0738831,3.8647461,5.7208252
					C147.6036835,190.7513275,145.5600739,192.372757,143.2685699,192.372757z" />
				<path className="fill" d="M117.8225632,208.8217163c-2.375206,0-4.4569473-1.7358398-4.8213882-4.1555481
					c-0.4004593-2.6665344,1.4355011-5.1529694,4.1009827-5.5539551l25.4152985-3.8250122
					c2.6750031-0.4031067,5.1529694,1.4344482,5.5544891,4.1004486c0.4004517,2.6665497-1.4355011,5.1529846-4.1009827,5.5539703
					l-25.4152908,3.8250122C118.3088303,208.8037109,118.0641022,208.8217163,117.8225632,208.8217163z" />
				<path className="fill" d="M129.0269012,227.2549438c-1.7745132,0-3.4844055-0.9698792-4.3488846-2.6569977
					c-1.2299805-2.3995667-0.2807465-5.3415527,2.1188202-6.5704651l22.8748245-11.718689
					c2.3963776-1.2299805,5.3415527-0.2802124,6.5704651,2.1188202c1.2299805,2.3995667,0.2807465,5.3415527-2.1188202,6.5704803
					l-22.8748169,11.7186737C130.5365601,227.0817413,129.7759094,227.2549438,129.0269012,227.2549438z" />
				<path className="fill" d="M129.7895966,200.7459259c0,0-6.3126526,41.8558044,71.5770874,41.8558044
					s71.5771027-41.8558044,71.5771027-41.8558044c0-62.5276031-34.2851257-83.408287-71.5771027-83.408287
					S129.7895966,138.2183228,129.7895966,200.7459259z" />
				<path className="fill fill--white" d="M201.2817688,246.1000366c-10.7256622,0-21.0442505-6.2400513-21.0442505-16.587677
					c0-13.2633209,10.1630402-16.1316376,10.1630402-16.1316376l10.8478699,2.6056366c0,0,0.0755768,0,0.0755768,0h0.0755768
					l10.8478699-2.6056366c0,0,10.1630402,2.8683167,10.1630402,16.1316376c0,10.3476257-10.3186035,16.587677-21.0442505,16.587677
					H201.2817688z" />
				<path className="fill fill--dark leopard--spot" d="M194.7651825,149.4967957c0.0110474,11.0092163,13.2237854,11.3435059,13.2030029-0.2455292
						C207.9481506,138.0716248,194.7545013,138.7789764,194.7651825,149.4967957z" />
				<path className="fill fill--dark leopard--spot" d="M178.746994,138.4436035c7.7924957,7.776886,17.3717041-1.3295593,9.162323-9.5095367
					C179.9899445,121.0430374,171.1608124,130.8725281,178.746994,138.4436035z" />
				<path className="fill fill--dark leopard--spot" d="M223.9863892,138.4436035c-7.792511,7.776886-17.3717041-1.3295593-9.162323-9.5095367
					C222.7434387,121.0430374,231.5725708,130.8725281,223.9863892,138.4436035z" />
				<path className="fill fill--dark leopard--spot" d="M207.9681702,119.3722382c-0.0011902-0.6661072-0.0521088-1.2871857-0.1412964-1.8695984
					c-2.1394196-0.1101837-4.2943268-0.1650085-6.4601593-0.1650085c-2.1484222,0-4.2861176,0.0540314-6.4085846,0.1626205
					c-0.1220245,0.6571045-0.1936646,1.3594894-0.1929474,2.1175003
					C194.7762451,130.6268921,207.9889679,130.9614105,207.9681702,119.3722382z" />
				<path className="fill--face" d="M201.3662415,222.3027802
					c-0.6699371-0.010437-1.3378448-0.1875153-1.9539032-0.5304565l-8.9451294-4.9795227c0,0-0.9540253-0.3971558-0.9540253-2.0123138
					c0-2.0688782,0.9606018-1.7815094,0.9629517-1.805191c0,0,7.5287628,1.2325897,10.8812103,1.2325897
					s10.8901062-1.2325897,10.8901062-1.2325897c0.0023346,0.0236816,0.9629364-0.2636871,0.9629364,1.805191
					c0,1.6151581-0.9540253,2.0123138-0.9540253,2.0123138l-8.9451141,4.9795227
					c-0.6160583,0.3429413-1.2839661,0.5200195-1.9539032,0.5304565H201.3662415z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Leopard/Heads.js